var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "w-full flex flex-col gap-5",
      attrs: { id: "package-details" }
    },
    [
      _c(
        "div",
        { staticClass: "py-6 px-6 flex gap-4 bg-pure-white rounded-2xl" },
        [
          _c(
            "div",
            { staticClass: "w-full flex flex-col gap-1" },
            [
              _c("BlTextBody2", {
                staticClass: "text-slate-700",
                attrs: { text: "Total items:" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "font-bold text-2xl" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.creditPackage.number_of_items) +
                    "\n      "
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "w-0.5 flex-shrink-0 bg-slate-400" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "w-full flex flex-col gap-1" },
            [
              _c("BlTextBody2", {
                staticClass: "text-slate-700",
                attrs: { text: "Total credits:" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "font-bold text-2xl" }, [
                _vm._v(_vm._s(_vm.creditPackage.total_credits))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "w-0.5 flex-shrink-0 bg-slate-400" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "w-full flex flex-col gap-1" },
            [
              _c("BlTextBody2", {
                staticClass: "text-slate-700",
                attrs: { text: "Total price:" }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex gap-1" },
                [
                  _c("BlTextSubtitle2", {
                    staticClass: "text-slate-600",
                    attrs: { text: _vm.currentCenter.currency_sym }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "font-bold text-2xl" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.priceFormats(_vm.creditPackage.total_price)
                        ) +
                        "\n        "
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "py-6 px-6 flex flex-col gap-4 bg-pure-white rounded-2xl"
        },
        [
          _c("BlTextTitle4", { attrs: { text: "Item details" } }),
          _vm._v(" "),
          _vm._l(_vm.creditPackage.package_services, function(service, idx) {
            return _c(
              "div",
              { key: service.id, staticClass: "flex flex-col gap-4" },
              [
                idx > 0
                  ? _c("div", { staticClass: "w-full h-px bg-slate-400" })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex flex-col gap-2" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "flex items-center gap-2",
                        attrs: { to: "/center/package-item", target: "_blank" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "font-semibold text-slate-1000 underline"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(service.package_item.name) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("BlIcon", {
                          staticClass: "h-4 w-4",
                          attrs: { icon: "square-up", color: "slate-8" }
                        }),
                        _vm._v(" "),
                        service.package_item.status === "archived"
                          ? _c("BlChip", {
                              attrs: {
                                chip: "Archived",
                                color: "rose",
                                dense: ""
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center justify-between" },
                      [
                        _c("BlTextBody2", {
                          staticClass: "text-slate-700",
                          attrs: { text: "Total credits" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: { text: service.session_credit }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center justify-between" },
                      [
                        _c("BlTextBody2", {
                          staticClass: "text-slate-700",
                          attrs: { text: "Standard retail price" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("BlTextBody2", {
                              attrs: { text: _vm.currentCenter.currency_sym }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              attrs: {
                                text: _vm.priceFormats(
                                  service.standard_retail_price
                                )
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center justify-between" },
                      [
                        _c("BlTextBody2", {
                          staticClass: "text-slate-700",
                          attrs: { text: "Total price" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("BlTextSubtitle3", {
                              attrs: { text: _vm.currentCenter.currency_sym }
                            }),
                            _vm._v(" "),
                            _c("BlTextSubtitle3", {
                              attrs: {
                                text: _vm.priceFormats(service.total_price)
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "py-6 px-6 flex flex-col bg-pure-white rounded-2xl" },
        [
          _c("BlTextTitle4", { attrs: { text: "Package details" } }),
          _vm._v(" "),
          _c("div", { staticClass: "py-4 flex gap-4" }, [
            _c(
              "div",
              { staticClass: "w-full flex flex-col gap-1" },
              [
                _c("BlTextBody2", {
                  staticClass: "text-slate-700",
                  attrs: { text: "Expiration days:" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "font-bold text-2xl" }, [
                  _vm._v(_vm._s(_vm.expirationDate))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "w-0.5 flex-shrink-0 bg-slate-400" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "w-full flex flex-col gap-1" },
              [
                _c("BlTextBody2", {
                  staticClass: "text-slate-700",
                  attrs: { text: "Maximum reschedules:" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "font-bold text-2xl" }, [
                  _vm._v(_vm._s(_vm.rescheduleCredit))
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "py-4 flex flex-col gap-1" },
            [
              _c("BlTextBody2", {
                staticClass: "text-slate-700",
                attrs: { text: "Package name:" }
              }),
              _vm._v(" "),
              _c("BlTextBody2", { attrs: { text: _vm.creditPackage.name } })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "h-px w-full bg-slate-400" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "py-4 flex flex-col gap-1" },
            [
              _c("BlTextBody2", {
                staticClass: "text-slate-700",
                attrs: { text: "Status:" }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center gap-1" },
                [
                  _c("BlChip", {
                    attrs: {
                      chip: _vm.packageChips[_vm.creditPackage.status].chip,
                      color: _vm.packageChips[_vm.creditPackage.status].color,
                      dense: ""
                    }
                  }),
                  _vm._v(" "),
                  _vm.creditPackage.archived_at
                    ? _c(
                        "div",
                        [
                          _c("BlTextBody2", { attrs: { text: "on" } }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            attrs: {
                              text: _vm.displayDate({
                                date: _vm.creditPackage.archived_at,
                                format: "DD MMMM YYYY"
                              })
                            }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", { attrs: { text: "by" } }),
                          _vm._v(" "),
                          !_vm.creditPackage.archiver
                            ? _c("BlTextBody2", { attrs: { text: "-" } })
                            : _c("BlTextBody2", {
                                class: {
                                  " italic": !_vm.creditPackage.archiver.name
                                },
                                attrs: {
                                  text:
                                    _vm.creditPackage.archiver.name ||
                                    "deleted user"
                                }
                              })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "h-px w-full bg-slate-400" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "py-4 flex flex-col gap-1" },
            [
              _c("BlTextBody2", {
                staticClass: "text-slate-700",
                attrs: { text: "Package description:" }
              }),
              _vm._v(" "),
              !_vm.creditPackage.description
                ? _c("BlTextBody2", {
                    staticClass: "italic text-slate-600",
                    attrs: { text: "No description" }
                  })
                : _c("BlTextBody2", {
                    staticClass: "whitespace-pre-line",
                    attrs: { text: _vm.creditPackage.description }
                  })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bf4b3bf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bf4b3bf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/center/package/PackageDetails.vue
// module id = null
// module chunks = 